import {
  FileSpreadsheet,
  BarChart3,
  FileText,
  ClipboardList,
  Shield,
  Network,
  Server,
  Monitor,
  AlertTriangle,
  Database,
  Globe,
  Package,
  Wrench,
  Camera,
} from 'lucide-react';

// APLICACIONES - Sección principal independiente
export const appsItems = [
  { name: 'Inventario', path: '/apps', pageKey: 'apps.applications', icon: 'AppWindow' },
  { name: 'Mapa Visual', path: '/apps/map', pageKey: 'apps.map', icon: 'GitBranch' },
  { name: 'Interfaces', path: '/apps/interfaces', pageKey: 'apps.interfaces', icon: 'Link2' },
];

// Assets items organized by sections
export const assetsSections = [
  {
    header: 'HOSTING',
    items: [
      { name: 'Motores SQL', path: '/assets/sql', pageKey: 'assets.sql' },
      { name: 'Servidores', path: '/assets/servers', pageKey: 'assets.servers' },
      { name: 'Storage', path: '/assets/nas', pageKey: 'assets.storage' },
    ]
  },
  {
    header: 'REDES',
    items: [
      { name: 'Access Points', path: '/assets/access-points', pageKey: 'assets.access_points' },
      { name: 'DNS', path: '/assets/dns', pageKey: 'assets.dns' },
      { name: 'Enlaces', path: '/assets/links', pageKey: 'assets.enlaces' },
      { name: 'Firewalls', path: '/assets/firewalls', pageKey: 'assets.firewalls' },
      { name: 'Switches', path: '/assets/switches', pageKey: 'assets.switches' },
    ]
  },
  {
    header: 'GOBIERNO',
    items: [
      { name: 'Certificados', path: '/assets/certificates', pageKey: 'assets.certificates' },
      { name: 'Licencias', path: '/assets/licenses', pageKey: 'assets.licencias' },
      { name: 'Tenants Cloud', path: '/assets/tenants', pageKey: 'assets.tenants' },
    ]
  },
  {
    header: 'DISPOSITIVOS VARIOS',
    items: [
      { name: 'Cámaras', path: '/assets/cameras', pageKey: 'assets.camaras' },
      { name: 'IoT', path: '/assets/iot', pageKey: 'assets.iot' },
      { name: 'UPS', path: '/assets/ups', pageKey: 'assets.ups' },
    ]
  },
  {
    header: 'VIRTUALIZACIÓN',
    items: [
      { name: 'Plataformas', path: '/infra/virt/platforms', pageKey: 'infra.virt_platforms', subHeader: 'VMware' },
      { name: 'Máquinas Virtuales', path: '/infra/virt/vms', pageKey: 'infra.virt_vms' },
      { name: 'Datastores', path: '/infra/virt/datastores', pageKey: 'infra.virt_datastores' },
      { name: 'Hosts Hyper-V', path: '/infra/hyperv/hosts', pageKey: 'infra.hyperv_hosts', subHeader: 'Hyper-V' },
      { name: 'VMs Hyper-V', path: '/infra/hyperv/vms', pageKey: 'infra.hyperv_vms' },
      { name: 'Storage Hyper-V', path: '/infra/hyperv/storage', pageKey: 'infra.hyperv_storage' },
      { name: 'Discos VHD', path: '/infra/hyperv/vhds', pageKey: 'infra.hyperv_vhds' },
    ]
  },
];

export const microSections = [
  {
    header: 'COMPUTACIÓN',
    items: [
      { name: 'Computadoras', path: '/micro/workstations', pageKey: 'assets.workstations' },
      { name: 'Monitores', path: '/micro/monitores', pageKey: 'micro.monitores' },
      { name: 'Tablets', path: '/micro/tablets', pageKey: 'micro.tablets' },
    ]
  },
  {
    header: 'COMUNICACIÓN',
    items: [
      { name: 'Celulares', path: '/micro/mobile-devices', pageKey: 'micro.mobile_devices' },
      { name: 'Teléfonos IP', path: '/micro/ip-phones', pageKey: 'micro.telefonos_ip' },
    ]
  },
  {
    header: 'PERIFÉRICOS Y SALAS',
    items: [
      { name: 'Impresoras', path: '/micro/printers', pageKey: 'micro.printers' },
      { name: 'Proyectores', path: '/micro/proyectores', pageKey: 'micro.proyectores' },
      { name: 'Televisores', path: '/micro/tvs', pageKey: 'micro.tvs' },
    ]
  },
  {
    header: 'OTROS',
    items: [
      { name: 'Relojes', path: '/micro/clocks', pageKey: 'micro.relojes' },
    ]
  },
];

export const microItems = microSections.flatMap(section => section.items);

// Config items organized by sections
export const configSections = [
  {
    header: 'APPS',
    items: [
      { name: 'Estados App', path: '/config/app-status', pageKey: 'config.app_status' },
      { name: 'Roles Responsable', path: '/config/app-roles', pageKey: 'config.app_roles' },
      { name: 'Tipos App', path: '/config/app-types', pageKey: 'config.app_types' },
      { name: 'Tipos BD', path: '/config/app-db-types', pageKey: 'config.app_db_types' },
      { name: 'Tipos Interfaz', path: '/config/app-interface-types', pageKey: 'config.app_interface_types' },
    ]
  },
  {
    header: 'ORGANIZACION',
    items: [
      { name: 'Clientes', path: '/config/clientes', pageKey: 'config.clientes' },
      { name: 'Empresas', path: '/config/empresas', pageKey: 'config.companies' },
      { name: 'Proveedores', path: '/config/proveedores', pageKey: 'config.proveedores' },
      { name: 'Sites', path: '/config/sites', pageKey: 'config.sites' },
      { name: 'Ubicaciones', path: '/config/ubicaciones', pageKey: 'config.locations' },
      { name: 'Usuarios', path: '/config/usuarios', pageKey: 'config.users' },
    ]
  },
  {
    header: 'CLASIFICACION',
    items: [
      { name: 'Criticidad', path: '/config/criticidad', pageKey: 'config.criticidad' },
      { name: 'Estados', path: '/config/estados', pageKey: 'config.estados' },
      { name: 'Tipos Dispositivo', path: '/config/tipos-dispositivo', pageKey: 'config.tipos_dispositivo' },
      { name: 'Tipos Impresora', path: '/config/tipos-printer', pageKey: 'config.tipos_printer' },
      { name: 'Tipos IoT', path: '/config/tipos-iot', pageKey: 'config.tipos_iot' },
      { name: 'Tipos Storage', path: '/config/tipos-storage', pageKey: 'config.tipos_storage' },
      { name: 'Tipos Vencimiento', path: '/config/tipos-vencimiento', pageKey: 'config.tipos_vencimiento' },
    ]
  },
  {
    header: 'INFRAESTRUCTURA',
    items: [
      { name: 'Ambientes', path: '/config/ambientes', pageKey: 'config.ambientes' },
      { name: 'Cloud', path: '/config/cloud', pageKey: 'config.cloud' },
      { name: 'Sistemas Operativos', path: '/config/sistemas-operativos', pageKey: 'config.sistemas_operativos' },
      { name: 'Ventanas Reinicio', path: '/config/ventanas-reinicio', pageKey: 'config.ventanas_reinicio' },
      { name: 'Herramientas de Backup', path: '/config/backup-tools', pageKey: 'config.backup_tools' },
      { name: 'Políticas de Backup', path: '/config/backup-policies', pageKey: 'config.backup_policies' },
    ]
  },
  {
    header: 'REDES',
    items: [
      { name: 'Modelos Access Points', path: '/config/modelos-ap', pageKey: 'config.modelos_ap' },
      { name: 'Modelos Firewalls', path: '/config/modelos-firewalls', pageKey: 'config.modelos_firewalls' },
      { name: 'Modelos Switches', path: '/config/modelos-switches', pageKey: 'config.modelos_switches' },
      { name: 'Roles Enlace', path: '/config/roles-enlace', pageKey: 'config.roles_enlace' },
      { name: 'Tipos Conexion', path: '/config/tipos-conexion', pageKey: 'config.tipos_conexion' },
      { name: 'Tipos Enlace', path: '/config/tipos-enlace', pageKey: 'config.tipos_enlace' },
    ]
  },
  {
    header: 'HARDWARE',
    items: [
      { name: 'DVR / NVR', path: '/config/dvrs', pageKey: 'config.dvrs' },
      { name: 'Marcas', path: '/config/marcas', pageKey: 'config.marcas' },
      { name: 'Modelos UPS', path: '/config/modelos-ups', pageKey: 'config.modelos_ups' },
    ]
  },
  {
    header: 'LICENCIAS',
    items: [
      { name: 'Tipos Licencia', path: '/config/tipos-licencia', pageKey: 'config.tipos_licencia' },
      { name: 'Tipos Vencimiento Lic.', path: '/config/tipos-vencimiento-licencias', pageKey: 'config.tipos_vencimiento' },
      { name: 'Tiempos Alerta', path: '/config/tiempos-alerta', pageKey: 'config.tiempos_alerta' },
    ]
  },
  {
    header: 'SISTEMA',
    items: [
      { name: 'Estado Agentes', path: '/config/agentes', pageKey: 'config.agentes' },
      { name: 'Catálogo KB', path: '/config/kb-catalog', pageKey: 'config.kb_catalog' },
    ]
  },
  {
    header: 'PREFERENCIAS',
    items: [
      { name: 'Tema', path: '/config/tema', pageKey: 'config.theme' },
    ]
  }
];

export const adminItems = [
  { name: 'Ibi', path: '/admin/ibi', pageKey: 'admin.ibi' },
  { name: 'Usuarios', path: '/admin/users', pageKey: 'config.users' },
  { name: 'Roles', path: '/admin/roles', pageKey: 'config.roles' },
];

export const adminSections = [
  { header: 'ADMINISTRACIÓN', items: adminItems },
];

export const ipamItems = [
  { name: 'Overview', path: '/ipam', pageKey: 'ipam.overview' },
  { name: 'L2 Domains', path: '/ipam/l2-domains', pageKey: 'ipam.l2_domains' },
  { name: 'VLANs', path: '/ipam/vlans', pageKey: 'ipam.vlans' },
  { name: 'Subnets', path: '/ipam/subnets', pageKey: 'ipam.subnets' },
  { name: 'Direcciones IP', path: '/ipam/addresses', pageKey: 'ipam.addresses' },
];

export const ipamSections = [
  { header: 'DIRECCIONAMIENTO', items: ipamItems },
];

export const reportsItems = [
  { 
    section: 'Ejecutivos',
    items: [
      { name: 'Resumen Mensual', path: '/reports/monthly', pageKey: 'reports.monthly', Icon: FileText, hidden: true },
    ]
  },
  { 
    section: 'Inventario',
    items: [
      { name: 'Inventario General', path: '/reports/inventory', pageKey: 'reports.inventory', Icon: FileSpreadsheet },
      { name: 'Por Marca', path: '/reports/by-brand', pageKey: 'reports.by_brand', Icon: BarChart3, hidden: true },
      { name: 'Por Site', path: '/reports/by-site', pageKey: 'reports.by_site', Icon: BarChart3, hidden: true },
      { name: 'Sin Asignar', path: '/reports/unassigned', pageKey: 'reports.unassigned', Icon: ClipboardList, hidden: true },
      { name: 'En Reparación', path: '/reports/repair', pageKey: 'reports.repair', Icon: ClipboardList, hidden: true },
    ]
  },
  { 
    section: 'Parches',
    items: [
      { name: 'Actualizaciones Instaladas', path: '/reports/patches', pageKey: 'reports.patches', Icon: Shield },
    ]
  },
  { 
    section: 'Red',
    items: [
      { name: 'Cambios de Red', path: '/reports/network-changes', pageKey: 'reports.discovery', Icon: Network },
    ]
  },
  { 
    section: 'Servidores',
    items: [
      { name: 'Compliance Servidores', path: '/reports/compliance-servers', pageKey: 'reports.compliance_servers', Icon: Server },
      { name: 'Por Sistema Operativo', path: '/reports/os', pageKey: 'reports.os', Icon: Monitor },
      { name: 'Sin Relevar', path: '/reports/pending-servers', pageKey: 'reports.pending_servers', Icon: AlertTriangle },
      { name: 'Cobertura de backups', path: '/reports/backup-coverage', pageKey: 'reports.backup_coverage', requiredPageKeys: ['assets.servers', 'assets.server_backups'], Icon: Database },
    ]
  },
  { 
    section: 'SQL Server',
    items: [
      { name: 'Sin Max Memory', path: '/reports/sql/no-maxmemory', pageKey: 'reports.sql_maxmemory', Icon: Database },
    ]
  },
  {
    section: 'Trazabilidad',
    items: [
      { name: 'Servidores', path: '/reports/traceability', pageKey: 'reports.traceability', Icon: Server },
      { name: 'SQL Server', path: '/reports/sql/traceability', pageKey: 'reports.sql_traceability', Icon: Database },
      { name: 'DNS Cambios', path: '/reports/dns/traceability', pageKey: 'reports.dns_traceability', Icon: Globe },
      { name: 'DNS Security', path: '/reports/dns/security', pageKey: 'reports.dns_traceability', Icon: Shield },
    ]
  },
  {
    section: 'Virtualización',
    items: [
      { name: 'Snapshots', path: '/reports/virt/snapshots', pageKey: 'reports.virt_snapshots', Icon: Database },
      { name: 'VMware Tools', path: '/reports/virt/tools', pageKey: 'reports.virt_tools', Icon: Wrench },
      { name: 'Checkpoints (Hyper-V)', path: '/reports/virt/hyperv/checkpoints', pageKey: 'reports.hyperv_checkpoints', Icon: Camera },
      { name: 'Integration Services', path: '/reports/virt/hyperv/tools', pageKey: 'reports.hyperv_tools', Icon: Wrench },
    ]
  },
  { 
    section: 'Workstations',
    items: [
      { name: 'Compliance Workstations', path: '/reports/compliance-workstations', pageKey: 'reports.compliance_workstations', Icon: Monitor },
      { name: 'Software Instalado', path: '/reports/software', pageKey: 'reports.software', Icon: Package },
    ]
  },
];
